var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"dark":"","padless":""}},[_c('v-card',{staticClass:"navy",attrs:{"flat":"","tile":"","width":"100%"}},[(!_vm.isNormal)?_c('StoreFront'):_c('v-container',[_c('Links'),_c('AppLinks'),_c('v-divider'),_c('LangSocial'),_c('v-divider'),_c('Ending')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }